import {
  styled,
  ToggleButtonGroup,
  toggleButtonGroupClasses,
} from '@mui/material';
import { alpha } from '@mui/material/styles';

export const AssistantGenerateRoutesDialogScheduleRouteCardFormToggleButtonGroup =
  styled(ToggleButtonGroup)(({ theme }) => ({
    gap: theme.spacing(2),

    [`& .${toggleButtonGroupClasses.grouped}`]: {
      borderRadius: '50%',
      width: 48,
      height: 48,
      borderColor: theme.palette.text.primary,
      color: theme.palette.text.primary,

      '&:hover': {
        backgroundColor: alpha(
          theme.palette.text.primary,
          theme.palette.action.hoverOpacity,
        ),
      },

      '&:not(:first-of-type)': {
        marginLeft: 0,
        borderLeftColor: theme.palette.text.primary,
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
      },

      '&:not(:last-of-type)': {
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
      },

      '&.Mui-selected': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,

        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },

        [`& + .${toggleButtonGroupClasses.grouped}.Mui-selected`]: {
          borderLeftColor: theme.palette.primary.dark,
          marginLeft: 0,
        },
      },
    },
  }));
